document.addEventListener("DOMContentLoaded", () => {

    const slider = document.querySelector(".sansu-review-slider");
    if (!slider) return;

    const track = slider.querySelector(".review-track");
    const cards = slider.querySelectorAll(".review-card");
    const next = slider.querySelector(".review-next");
    const prev = slider.querySelector(".review-prev");

    if (!track || cards.length === 0) return;

    let index = 0;
    let startX = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let dragging = false;
    let autoplay;

    function visibleCards() {
        if (window.innerWidth < 768) return 1;
        if (window.innerWidth < 1200) return 2;
        return 3;
    }

    function cardWidth() {
        return cards[0].getBoundingClientRect().width + 24;
    }

    function maxIndex() {
        return Math.max(cards.length - visibleCards(), 0);
    }

    function updateSlider(animated = true) {

        if (!animated) {
            track.style.transition = "none";
        } else {
            track.style.transition = "transform .45s ease";
        }

        currentTranslate = -(index * cardWidth());

        track.style.transform =
            `translate3d(${currentTranslate}px,0,0)`;
    }

    function nextSlide() {
        index++;

        if (index > maxIndex()) {
            index = 0;
        }

        updateSlider();
    }

    function prevSlide() {
        index--;

        if (index < 0) {
            index = maxIndex();
        }

        updateSlider();
    }

    next?.addEventListener("click", nextSlide);
    prev?.addEventListener("click", prevSlide);

    function startAuto() {
        stopAuto();
        autoplay = setInterval(nextSlide, 4000);
    }

    function stopAuto() {
        clearInterval(autoplay);
    }

    slider.addEventListener("mouseenter", stopAuto);
    slider.addEventListener("mouseleave", startAuto);

    track.addEventListener("pointerdown", dragStart);
    window.addEventListener("pointermove", dragMove);
    window.addEventListener("pointerup", dragEnd);

    function dragStart(e) {
        dragging = true;
        startX = e.clientX;
        prevTranslate = currentTranslate;
        track.style.cursor = "grabbing";
        stopAuto();
    }

    function dragMove(e) {

        if (!dragging) return;

        const delta = e.clientX - startX;

        track.style.transition = "none";

        track.style.transform =
            `translate3d(${prevTranslate + delta}px,0,0)`;
    }

    function dragEnd(e) {

        if (!dragging) return;

        dragging = false;

        const moved = e.clientX - startX;

        if (moved < -80) {
            nextSlide();
        } else if (moved > 80) {
            prevSlide();
        } else {
            updateSlider();
        }

        track.style.cursor = "grab";

        startAuto();
    }

    window.addEventListener("resize", () => {

        if (index > maxIndex()) {
            index = maxIndex();
        }

        updateSlider(false);

    });

    updateSlider(false);
    startAuto();

});